import {getEnvironment} from '@sail/utils';
import {QA_R_URL, R_URL} from 'src/internal/metrics/endpoints';

import type {MetricEvent, MetricsTransport} from 'src/internal/metrics/types';
import type {FetchFn} from 'src/internal/transport/types';

function serializeMetricEvent(event: MetricEvent): URLSearchParams {
  return new URLSearchParams({
    ...event.params,
    event_name: event.name,
    ...event.meta,
  });
}

export default function createImmediateMetricsTransport(params: {
  fetch: FetchFn;
}): MetricsTransport {
  return {
    send(event: MetricEvent): void {
      const url = getEnvironment() === 'production' ? R_URL : QA_R_URL;
      params.fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        mode: 'no-cors',
        keepalive: true,
        body: serializeMetricEvent(event),
      });
    },
  };
}
